$(document).ready(function () {
  // Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
  $(document).on("click", "[data-url_target]", function (e) {
    var url = $(this).data("url_target");
    window.location.href = url;
    return false;
  });

  /*
   * a11y — WCAG 2.1.1 (C8XG7) : certains [data-url_target] portent role="link" et
   * tabindex="0" (raccourcis de taille des cartes produit). Contrairement a un <a>
   * natif, un role=link ne navigue pas sur Entree : on cable la touche ici.
   * Espace est volontairement ignore — un lien ne s'active pas a l'Espace.
   */
  $(document).on("keydown", "[data-url_target][role='link']", function (e) {
    if (e.key !== "Enter") return;
    if (this.getAttribute("aria-disabled") === "true") return;
    e.preventDefault();
    window.location.href = $(this).data("url_target");
  });

  // Gestion du menu (desktop)
  // Écoute des clics sur les éléments du menu (lien dont l'attribut aria-controls contient menu_drawer_*)
  $(".main_menu [aria-controls^='menu_drawer_']").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Récupération de la target sous menu
    var $target = $("#" + $(this).attr("aria-controls"));

    var $drawer = $(".main_navigation");

    // Si le menu est fermé (aria-expanded = false)
    if ($drawer.attr("data-visible") == "false") {
      // On l'ouvre
      $drawer.attr("data-visible", "true");

      // On ajoute la class "no-scroll" sur le body pour empêcher le scroll
      $("body").addClass("no-scroll");

      // On place l'ensemble des éléments qui controle le drawer en aria-expanded = true
      $("[aria-controls='menu_drawer']").attr("aria-expanded", "true");
    }

    // On ouvre de la même facon la $target
    $target.attr("data-visible", "true");

    // On ferme tous les autres sous menu
    $drawer.find("[data-visible]").not($target.get(0)).attr("data-visible", "false");

    // Ansi que ces enfants
    $("#" + $target.attr("id") + " [aria-controls]").attr("aria-expanded", "true");
    $target.find("[data-visible='false']").attr("data-visible", "true");

    // On place l'ensemble des éléments qui controle le menu ouvert en aria-expanded = true
    $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "true");

    // On place l'ensemble des éléments qui contrôle les sous menu fermés en aria-expanded = false
    $drawer
      .find("[aria-controls^='menu_drawer_']")
      .not("[aria-controls='" + $target.attr("id") + "']")
      .attr("aria-expanded", "false");
  });

  // Gestion des liens dans le menu drawer ouver
  $(".main_navigation [aria-controls^='menu_drawer_']").click(function (e) {
    e.preventDefault();

    var $target = $("#" + $(this).attr("aria-controls"));
    if ($target.attr("data-visible") == "true") {
      // On place l'ensemble des éléments qui controle le menu fermé en aria-expanded = false
      $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "false");
      $target.attr("data-visible", "false").hide();
    } else {
      // Si on est en desktop
      $target.parents("ul").first().find("[data-visible]").not($target.get(0)).attr("data-visible", "false").hide();

      if (window.innerWidth > 989) {
        // On ouvre les sous-menu associés à la target
        $("#" + $target.attr("id"))
          .find("[data-visible='false'][data-open-first-desktop='true']")
          .attr("data-visible", "true")
          .show();

        // On place l'ensemble des éléments qui controle le menu ouvert en aria-expanded = true
        $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "true");
      } else {
        // On ouvre les sous-menu associés à la target
        $("#" + $target.attr("id"))
          .find("[data-visible='false'][data-open-first-mobile='true']")
          .attr("data-visible", "true")
          .show();

        // On place l'ensemble des éléments qui controle le menu ouvert en aria-expanded = true
        $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "true");
      }

      // On place l'ensemble des éléments qui contrôle les sous menu fermés en aria-expanded = false
      $target
        .parents("ul")
        .first()
        .find("[aria-controls^='menu_drawer_']")
        .not("[aria-controls='" + $target.attr("id") + "']")
        .attr("aria-expanded", "false");

      $target.slideDown(200, function () {
        $target.attr("data-visible", "true");
      });
    }
  });

  // Si on clique en dehors du menu, on le ferme, et qu'on ne clique sur élément du menu ([aria-controls^='menu_drawer_'])
  $(document).click(function (e) {
    if ((!$(e.target).closest(".main_navigation nav").length || $(e.target).parents(".close_menu").length) && !$(e.target).closest(".popin").length) {
      // On place l'ensemble des éléments qui controle le drawer en aria-expanded = false
      $("[aria-controls='menu_drawer']").attr("aria-expanded", "false");

      // On place l'ensemble des éléments qui contrôle les sous menu fermés en aria-expanded = false
      $("[aria-controls^='menu_drawer_']").attr("aria-expanded", "false");

      // Fermeture du menu
      $(".main_navigation").attr("data-visible", "false");
      $(".main_navigation [data-visible]").attr("data-visible", "false");
      $("body").removeClass("no-scroll");
    }
  });

  // Si on ne clique pas sur un élément du menu, on le ferme
  $("[aria-controls^='menu_drawer_']").click(function (e) {
    e.stopPropagation();
  });

  // Lien permettant d'ouvrir le menu sur mobile
  $("[aria-controls='menu_drawer']")
    .not(".close_menu")
    .click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      // On place l'ensemble des éléments qui controle le drawer en aria-expanded = true
      $("[aria-controls='menu_drawer']").attr("aria-expanded", "true");

      // Fermeture du menu
      $(".main_navigation").attr("data-visible", "true");

      // On ajoute la class "no-scroll" sur le body pour empêcher le scroll
      $("body").addClass("no-scroll");
    });

  // Fiche produit, scroll pour afficher le footer fixed avec le buy button

  // Au scroll
  if ($(".mobile_buy_button_wrapper").length) {
    // si la fenêtre fait moins que 750px
    if (window.innerWidth < 750) {
      // Si le footer est visible
      if (!isInViewport($(".product-form__submit").first().get(0))) {
        // On cache le buy button

        // Si le bouton ".product-form__submit" est au dessus du viewport (une fois qu'on a scrollé), on affiche le buy button
        // Valeur du scroll en hauteur
        var scroll_top = $(window).scrollTop();
        if (scroll_top > $(".product-form__submit").first().offset().top) {
          $(".mobile_buy_button_wrapper").slideDown(200);
        } else {
          $(".mobile_buy_button_wrapper").slideUp(200);
        }
      } else {
        // Sinon on l'affiche
        $(".mobile_buy_button_wrapper").slideUp(200);
      }
    }

    $(window).scroll(function () {
      if (window.innerWidth < 750) {
        // Si le footer est visible
        if (!isInViewport($(".product-form__submit").first().get(0))) {
          // On cache le buy button

          // Si le bouton ".product-form__submit" est au dessus du viewport (une fois qu'on a scrollé), on affiche le buy button
          // Valeur du scroll en hauteur
          var scroll_top = $(window).scrollTop();
          if (scroll_top > $(".product-form__submit").first().offset().top) {
            $(".mobile_buy_button_wrapper").slideDown(200);
          } else {
            $(".mobile_buy_button_wrapper").slideUp(200);
          }
        } else {
          // Sinon on l'affiche
          $(".mobile_buy_button_wrapper").slideUp(200);
        }
      }
    });

    // Au clic sur le bouton ".mobile_buy_button_wrapper button", on scroll la page de façon smooth jusqu'à l'élément "<product-form>"
    $(".mobile_buy_button_wrapper button").click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      // On scroll la page de façon smooth jusqu'à l'élément "<product-form>", de façon a ce que ce dernier soit centré dans la fenêtre
      $("html, body").animate(
        {
          scrollTop: $(".product-form__submit").first().offset().top - window.innerHeight / 2 + $(".product-form__submit").first().outerHeight() / 2,
        },
        200
      );
    });
  }

  // Collection : Contenu Bas de page
  $(".collection_seo_content .toggle_seo_content span").click(function (e) {
    if ($(this).data("action") == "expand") {
      $(this).parents(".collection_seo_content").addClass("expanded");
    } else {
      $(this).parents(".collection_seo_content").removeClass("expanded");
    }
  });

  // Gestion des popins
  $(".popin_overlay").click(function (e) {
    $("body").removeClass("no-scroll");
    $(".popin_wrapper").fadeOut(400, function () {
      // Suppression du contenu de la popin
      $(".popin").remove();
    });
  });

  $(".popin_overlay *")
    .not(".popin_close")
    .click(function (e) {
      e.stopPropagation();
    });

  // Lien pour fermer la popin
  $(document).on("click", ".popin_close", function (e) {
    $(".popin_overlay").click();
  });

  // Bouton "Esc" pour fermer la popin
  $(document).on("keydown", function (e) {
    if (e.keyCode == 27 && $(".popin_wrapper").is(":visible")) {
      $(".popin_overlay").click();
    }
  });

  // Click sur les liens concernés par la popin
  $("[data-popin=1]").click(function (e) {
    e.stopPropagation();
    e.preventDefault();

    // On récupère la section à loader
    var section = $(this).data("target");
    var fetch_base_url = $(this).data("fetch-base-url") || "";

    // On fecth le contenu de la section
    $.get(fetch_base_url + "/?section_id=" + section, function (data) {
      // On crée la popin
      var html = data;

      // On prepend et on affiche la zone .popin_wrapper avec le contenu de la popin
      $("body").addClass("no-scroll");
      $(".popin_wrapper > div").prepend(html);
      $(".popin_wrapper").fadeIn(400);
    });
  });

  // Custom select
  if ($(".custom-select").length) {
    // a11y — WCAG 2.1.1 / 4.1.2 (US9L3) : .select-selected porte role=button et
    // tabindex=0 (voir snippets/facets.liquid). Contrairement a un <button> natif, un
    // role=button ne declenche pas de clic sur Entree ni Espace : il faut donc gerer
    // ces touches ici, et tenir aria-expanded a jour a chaque ouverture/fermeture.
    const isOpen = function ($customSelect) {
      return !$customSelect.find(".select-items").hasClass("select-hide");
    };

    // Etat explicite plutot qu'un toggle : deux bascules independantes sur une meme
    // activation s'annulaient (voir activate ci-dessous).
    const setOpen = function ($customSelect, open) {
      $customSelect.find(".select-items").toggleClass("select-hide", !open);
      $customSelect.find(".select-selected").attr("aria-expanded", open ? "true" : "false");
    };

    /*
     * Point d'entree unique pour toute activation du declencheur, souris comme clavier.
     *
     * Une frappe Entree ou Espace sur .select-selected est suivie d'un evenement `click`
     * sur le meme element. Avec un toggle dans le handler clavier ET un toggle dans le
     * handler de clic, la liste s'ouvrait puis se refermait aussitot : le menu semblait
     * ne pas reagir au clavier. On dedoublonne donc les activations rapprochees, pour
     * qu'un seul geste utilisateur ne produise qu'une seule bascule.
     */
    let lastActivation = 0;
    const activate = function ($customSelect) {
      const now = Date.now();
      if (now - lastActivation < 200) return;
      lastActivation = now;
      setOpen($customSelect, !isOpen($customSelect));
    };

    const closeAll = function () {
      $(".custom-select").each(function () {
        setOpen($(this), false);
      });
    };

    $(document).on("click", ".custom-select", function (e) {
      e.stopPropagation();
      activate($(this));
    });

    $(document).on("keydown", ".select-selected", function (e) {
      // « Spacebar » : anciens Edge/IE, encore renvoye par quelques navigateurs
      if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
      e.preventDefault(); // Espace ferait defiler la page
      activate($(this).closest(".custom-select"));
    });

    // Echap referme la liste et rend le focus au declencheur
    $(document).on("keydown", ".custom-select", function (e) {
      if (e.key !== "Escape") return;
      const $customSelect = $(this);
      if (!isOpen($customSelect)) return;
      setOpen($customSelect, false);

      // preventScroll : la liste reste ouverte pendant que l'utilisateur defile, et le
      // declencheur est haut dans la page. Un focus() nu ramenerait brutalement le
      // scroll en haut au moment d'appuyer sur Echap.
      const trigger = $customSelect.find(".select-selected")[0];
      if (trigger) trigger.focus({ preventScroll: true });
    });

    $(document).on("click", closeAll);

    $(".custom-select .select-items input[type='radio']").on("change", function () {
      const $customSelect = $(this).closest(".custom-select");
      $customSelect.find(".select-selected").text($(this).next().text());
      setOpen($customSelect, false);
    });
  }
});

/*
 * a11y — WCAG 2.4.3 (WVBGZ, QNW3Z, ELWKT, G70VU) : focus dans les slides masquees.
 *
 * Les carrousels Swiper du theme laissent toutes les slides dans le flux, simplement
 * decalees hors cadre. Leur contenu reste donc focusable : en tabulant, l'utilisateur
 * traverse des dizaines de liens invisibles avant d'atteindre l'element suivant, et
 * peut se retrouver « piege » dans un carrousel en boucle.
 *
 * On retire de l'ordre de tabulation ce qui se trouve dans une slide non visible.
 * Choix de tabindex="-1" plutot que de l'attribut `inert` : si la detection de
 * visibilite se trompe, le pire cas est un arret de tabulation manquant, jamais un
 * clic mort. `inert` aurait rendu la slide non cliquable.
 *
 * La valeur d'origine est memorisee pour etre restauree quand la slide redevient
 * visible. On observe les changements de classe plutot que les evenements Swiper :
 * les instances sont creees dans des scripts inline a des moments variables, et
 * plusieurs systemes de slider coexistent dans le theme.
 */
(function () {
  const SELECTEUR_FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function majSlide(slide) {
    const visible = slide.classList.contains("swiper-slide-visible");
    slide.querySelectorAll(SELECTEUR_FOCUSABLE).forEach((el) => {
      if (visible) {
        if (el.dataset.a11yTabindex === undefined) return;
        if (el.dataset.a11yTabindex === "") el.removeAttribute("tabindex");
        else el.setAttribute("tabindex", el.dataset.a11yTabindex);
        delete el.dataset.a11yTabindex;
      } else {
        if (el.dataset.a11yTabindex !== undefined) return;
        el.dataset.a11yTabindex = el.getAttribute("tabindex") || "";
        el.setAttribute("tabindex", "-1");
      }
    });
  }

  function majCarrousel(swiper) {
    swiper.querySelectorAll(".swiper-slide").forEach(majSlide);
  }

  /*
   * a11y — WCAG 4.1.3 (J5QFQ, M5QAF, TER3D) : annonce du changement de diapositive.
   *
   * Une seule region live pour tous les carrousels de la page. `polite` pour ne pas
   * couper la lecture en cours, et `atomic` pour que le message soit lu en entier.
   */
  let regionLive = null;
  function annoncer(message) {
    if (!regionLive) {
      regionLive = document.createElement("div");
      regionLive.className = "visually-hidden";
      regionLive.setAttribute("role", "status");
      regionLive.setAttribute("aria-live", "polite");
      regionLive.setAttribute("aria-atomic", "true");
      document.body.appendChild(regionLive);
    }
    // Vider d'abord : un contenu identique deux fois de suite ne serait pas reannonce
    regionLive.textContent = "";
    window.setTimeout(() => {
      regionLive.textContent = message;
    }, 50);
  }

  function messageDiapositive(index, total) {
    const s = window.accessibilityStrings || {};
    const nom = s.sliderName || "";
    const de = s.sliderOf || "/";
    return (nom ? nom + " : " : "") + index + " " + de + " " + total;
  }

  function init() {
    initSwiper();
    initSliderDawn();
  }

  function initSwiper() {
    document.querySelectorAll(".swiper").forEach((swiper) => {
      if (swiper.dataset.a11yInit) return;
      swiper.dataset.a11yInit = "1";

      /*
       * M5QAF : le module a11y de Swiper pose aria-live="polite" sur .swiper-wrapper.
       * Tout le contenu du carrousel est donc relu a chaque changement de diapositive,
       * au lieu d'une notification courte. On desactive cette region et on annonce
       * nous-memes, de maniere concise.
       */
      const wrapper = swiper.querySelector(".swiper-wrapper");
      if (wrapper) wrapper.setAttribute("aria-live", "off");

      majCarrousel(swiper);

      let enAttente = null;
      let dernierIndex = null;
      const observateur = new MutationObserver(() => {
        // Swiper reecrit les classes de plusieurs slides par transition : on regroupe
        window.clearTimeout(enAttente);
        enAttente = window.setTimeout(() => {
          majCarrousel(swiper);

          const slides = Array.from(swiper.querySelectorAll(".swiper-slide"));
          const index = slides.findIndex((s) => s.classList.contains("swiper-slide-active"));
          // J5QFQ : on n'annonce que si l'utilisateur a la main sur le carrousel,
          // sinon un defilement automatique bavarderait en continu.
          if (index >= 0 && index !== dernierIndex && swiper.contains(document.activeElement)) {
            annoncer(messageDiapositive(index + 1, slides.length));
          }
          dernierIndex = index;
        }, 60);
      });

      swiper.querySelectorAll(".swiper-slide").forEach((slide) => {
        observateur.observe(slide, { attributes: true, attributeFilter: ["class"] });
      });
    });
  }

  /*
   * a11y — WCAG 2.4.3 / 4.1.3 (C659Z, TER3D) : le tiroir panier et quelques sections
   * utilisent l'autre systeme de slider du theme, le <slider-component> de Dawn, qui
   * fait defiler une liste en overflow. Toutes les slides restent donc focusables, et
   * aucun changement n'est annonce.
   *
   * On s'appuie sur les outils du composant lui-meme : sa methode isSlideVisible() et
   * son evenement slideChanged, plutot que de redetecter la visibilite a la main.
   */
  function initSliderDawn() {
    document.querySelectorAll("slider-component").forEach((composant) => {
      if (composant.dataset.a11yInit) return;
      if (typeof composant.isSlideVisible !== "function") return;
      composant.dataset.a11yInit = "1";

      const slides = () => composant.querySelectorAll('[id^="Slide-"]');

      const majFocus = () => {
        slides().forEach((slide) => {
          const visible = composant.isSlideVisible(slide);
          slide.querySelectorAll(SELECTEUR_FOCUSABLE).forEach((el) => {
            if (visible) {
              if (el.dataset.a11yTabindex === undefined) return;
              if (el.dataset.a11yTabindex === "") el.removeAttribute("tabindex");
              else el.setAttribute("tabindex", el.dataset.a11yTabindex);
              delete el.dataset.a11yTabindex;
            } else {
              if (el.dataset.a11yTabindex !== undefined) return;
              el.dataset.a11yTabindex = el.getAttribute("tabindex") || "";
              el.setAttribute("tabindex", "-1");
            }
          });
        });
      };

      majFocus();

      composant.addEventListener("slideChanged", (event) => {
        majFocus();
        const total = slides().length;
        const index = event.detail && event.detail.currentPage;
        if (index && total && composant.contains(document.activeElement)) {
          annoncer(messageDiapositive(index, total));
        }
      });

      const zone = composant.querySelector('[id^="Slider-"]');
      if (zone) {
        let enAttente = null;
        zone.addEventListener("scroll", () => {
          window.clearTimeout(enAttente);
          enAttente = window.setTimeout(majFocus, 120);
        });
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Les carrousels sont instancies apres coup par des scripts inline : on repasse
  // une fois la page complete pour prendre en compte les slides ajoutees entre-temps.
  window.addEventListener("load", () => window.setTimeout(init, 500));
})();

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

/*** Gestion des drawer popin ***/
class DrawerPopinWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Si on clic en dehors du div enfant du drawer popin, on le ferme
    document.addEventListener("click", (event) => {
      if(event.target.closest("drawer-popin")) {
        return;
      }
      this.close();
    });
  }

  open(contextUrl, sectionTarget) {
    fetch(`${contextUrl}/?section_id=${sectionTarget}`)
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html").querySelector("drawer-popin").outerHTML;
        this.querySelector("div").innerHTML = html;

        // On affiche le drawer popin
        $(".drawer_popin_wrapper").css("display", "flex").hide().fadeIn(400);
        $(".drawer_popin_wrapper").addClass("open");

        // A11y : annonce du dialogue aux lecteurs d'ecran + focus dans le drawer
        this.setupA11y();

        // On supprimer les scripts et on les remet dans le body
        this.querySelectorAll("script").forEach((oldScriptTag) => {

          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      })
      .catch((error) => {
        return;
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  // Ouverture à partir d'un contenu déjà présent sur la page (pas d'AJAX).
  // Utilisé par les openers ayant un data-inline-target pointant vers un <template>.
  openInline(html) {
    this.querySelector("div").innerHTML = html;

    $(".drawer_popin_wrapper").css("display", "flex").hide().fadeIn(400);
    $(".drawer_popin_wrapper").addClass("open");

    // A11y : annonce du dialogue aux lecteurs d'ecran + focus dans le drawer
    this.setupA11y();
  }

  // A11y : le drawer est un dialogue modal. On memorise le declencheur, on
  // deplace le focus dans le drawer (il porte role="dialog" + tabindex="-1")
  // et on enferme la tabulation dans le dialogue tant qu'il est ouvert.
  setupA11y() {
    const drawer = this.querySelector("drawer-popin");
    if (!drawer) return;

    this.previouslyFocused = document.activeElement;

    // Le focus entre dans le dialogue : les lecteurs d'ecran annoncent alors
    // son role et son nom accessible (aria-labelledby sur le titre).
    drawer.focus();

    this.trapFocusHandler = (event) => {
      if (event.key !== "Tab") return;

      const focusable = Array.from(
        drawer.querySelectorAll('a[href], button:not([disabled]), [role="button"], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetParent !== null);

      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener("keydown", this.trapFocusHandler);
  }

  close() {
    if (this.trapFocusHandler) {
      document.removeEventListener("keydown", this.trapFocusHandler);
      this.trapFocusHandler = null;
    }

    $(".drawer_popin_wrapper").removeClass("open");
    $(".drawer_popin_wrapper").fadeOut(400, function () {
      $("drawer-popin").remove();
    });

    // A11y : on rend le focus au declencheur
    if (this.previouslyFocused && typeof this.previouslyFocused.focus === "function") {
      this.previouslyFocused.focus();
      this.previouslyFocused = null;
    }
  }
}

customElements.define("drawer-popin-wrapper", DrawerPopinWrapper);

/*** Contenu du drawer popin ***/
class DrawerPopin extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector(".popin_close");
    this.drawerPopinWrapper = this.closest("drawer-popin-wrapper");
  }

  connectedCallback() {
    this.closeButton.addEventListener("click", () => {
      console.log("close");
      this.drawerPopinWrapper.close();
    });

    // Escape pour fermer le drawer popin
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.drawerPopinWrapper.close();
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.drawerPopinWrapper.close();
      }
    });
  }
}

customElements.define("drawer-popin", DrawerPopin);

/*** Opener du drawer popin ***/
class DrawerPopinOpener extends HTMLElement {
  constructor() {
    super();

    this.contextUrl = this.dataset.contextUrl;
    this.sectionTarget = this.dataset.sectionTarget;
    this.clickableElement = this.querySelector("span");
    this.drawerPopinWrapper = document.querySelector("drawer-popin-wrapper");
  }

  connectedCallback() {
    this.clickableElement.addEventListener("click", debounce((event) => {
      // Si un contenu inline (template déjà sur la page) est ciblé, on l'ouvre sans AJAX
      if (this.dataset.inlineTarget) {
        const template = document.getElementById(this.dataset.inlineTarget);
        if (template) {
          this.drawerPopinWrapper.openInline(template.innerHTML);
        }
        return;
      }
      // Sinon, on open le drawer popin via AJAX
      this.drawerPopinWrapper.open(this.contextUrl, this.sectionTarget);
    }, 100));
  }
}

customElements.define("drawer-popin-opener", DrawerPopinOpener);

/*** ------------------------------------------------------------------
 * Accessibilite (WCAG 2.1 AA)
 * ------------------------------------------------------------------ */

/**
 * 1. Activation au clavier des declencheurs role="button".
 *
 * Le theme utilise des <span role="button"> (burger, fermeture du menu,
 * fermeture des drawers, ouverture du guide des tailles / dispo boutique).
 * Contrairement a un <button>, un span ne repond pas nativement a Entree /
 * Espace : on rejoue donc le clic. WCAG 2.1.1 (Clavier), 4.1.2 (Nom, role...).
 */
document.addEventListener("keydown", (event) => {
  if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") return;
  if (!event.target || typeof event.target.closest !== "function") return;

  const trigger = event.target.closest('[role="button"]');
  if (!trigger) return;

  // IMPORTANT : on n'intervient QUE sur les elements non nativement activables.
  // Le theme pose deja role="button" sur des <summary> (global.js) et sur des
  // liens de facettes (facets.js), qui repondent nativement a Entree/Espace :
  // rejouer le clic provoquerait un double declenchement.
  const nativelyActivatable = ["A", "BUTTON", "SUMMARY", "INPUT", "SELECT", "TEXTAREA"];
  if (nativelyActivatable.indexOf(trigger.tagName) !== -1) return;

  // On evite le scroll de la page provoque par la barre d'espace
  event.preventDefault();
  trigger.click();
});

$(document).ready(function () {
  // Dernier declencheur de menu active : sert a rendre le focus a la fermeture
  let lastMenuTrigger = null;

  /**
   * 2. Deplacement du focus dans le sous-menu deplie.
   *
   * Les declencheurs de la barre (.main_menu) pointent via aria-controls vers
   * des <ul id="menu_drawer_..."> situes dans un tout autre conteneur
   * (.main_navigation) : en tabulant, on n'atteignait jamais ces liens.
   * On deplace donc le focus sur le premier lien du sous-menu ouvert.
   * WCAG 2.4.3 (Parcours du focus).
   */
  $(".main_menu [aria-controls^='menu_drawer_'], .main_navigation [aria-controls^='menu_drawer_']").on("click", function () {
    const trigger = this;
    lastMenuTrigger = trigger;

    // On laisse les handlers existants mettre a jour aria-expanded / data-visible
    window.setTimeout(function () {
      if (trigger.getAttribute("aria-expanded") !== "true") return;

      const targetId = trigger.getAttribute("aria-controls");
      const target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      const focusable = Array.from(target.querySelectorAll('a[href], button:not([disabled]), [role="button"]')).filter(
        (el) => el.offsetParent !== null
      );

      if (focusable.length) focusable[0].focus();
    }, 0);
  });

  // Memorise aussi l'ouverture du menu mobile (burger) pour le retour de focus
  $("[aria-controls='menu_drawer']").not(".close_menu").on("click", function () {
    lastMenuTrigger = this;
  });

  /**
   * 3. Fermeture du menu par Echap + retour du focus au declencheur.
   * WCAG 2.1.2 (Pas de piege au clavier), 2.4.3.
   */
  $(document).on("keydown", function (event) {
    if (event.key !== "Escape") return;

    const $nav = $(".main_navigation");
    if ($nav.attr("data-visible") !== "true") return;

    $("[aria-controls='menu_drawer']").attr("aria-expanded", "false");
    $("[aria-controls^='menu_drawer_']").attr("aria-expanded", "false");
    $nav.attr("data-visible", "false");
    $nav.find("[data-visible]").attr("data-visible", "false");
    $("body").removeClass("no-scroll");

    if (lastMenuTrigger && typeof lastMenuTrigger.focus === "function") {
      lastMenuTrigger.focus();
      lastMenuTrigger = null;
    }
  });

  /**
   * 4. Activation clavier du bouton de fermeture du menu.
   * WCAG 2.1.1 (Clavier) — FHSDN.
   *
   * .close_menu est un <span role="button" tabindex="0"> : il est atteignable au clavier,
   * mais la fermeture n'etait cablee que sur le handler de clic au niveau du document. Or
   * un role=button, contrairement a un <button> natif, ne declenche pas de clic sur Entree
   * ni Espace — le bouton etait donc atteignable et inoperant. Constate a 200 % comme a
   * 400 %, ou c'est le seul moyen de fermer le menu affiche en pleine page.
   */
  $(document).on("keydown", ".close_menu", function (event) {
    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") return;
    event.preventDefault(); // Espace ferait defiler la page

    const $nav = $(".main_navigation");
    if ($nav.attr("data-visible") !== "true") return;

    $("[aria-controls='menu_drawer']").attr("aria-expanded", "false");
    $("[aria-controls^='menu_drawer_']").attr("aria-expanded", "false");
    $nav.attr("data-visible", "false");
    $nav.find("[data-visible]").attr("data-visible", "false");
    $("body").removeClass("no-scroll");

    if (lastMenuTrigger && typeof lastMenuTrigger.focus === "function") {
      lastMenuTrigger.focus();
      lastMenuTrigger = null;
    }
  });
});

/**
 * Polyptique : décalage de départ des vidéos en lecture automatique.
 *
 * Réglage « Décalage (secondes) » du bloc vidéo, posé en data-video-offset sur le
 * conteneur. Usage type : la même vidéo répétée côte à côte pour remplir une bannière,
 * chaque copie démarrant à un moment différent. On fait commencer la vidéo directement
 * à N secondes plutôt que de retarder sa lecture : toutes les copies tournent dès
 * l'arrivée sur la page, sans image figée, et la boucle conserve l'écart (même durée).
 */
(function () {
  const appliquerDecalage = (video, decalage) => {
    const positionner = () => {
      if (!video.duration || !isFinite(video.duration)) return;
      video.currentTime = decalage % video.duration;
    };

    if (video.readyState >= 1) positionner();
    else video.addEventListener("loadedmetadata", positionner, { once: true });
  };

  const init = (racine) => {
    racine.querySelectorAll("[data-video-offset]").forEach((conteneur) => {
      const decalage = parseFloat(conteneur.dataset.videoOffset);
      const video = conteneur.querySelector("video");
      if (!video || !decalage || decalage <= 0) return;
      appliquerDecalage(video, decalage);
    });
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init(document));
  else init(document);

  // Éditeur de thème : la section est re-rendue à chaque modification de réglage.
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
